import React, { useEffect, useState } from 'react'

import { API, Card } from '@enkla-gui'
import { icons } from '@config'

export default function PremadeReports({ onLoadReport }) {
	const [reports, setReports] = useState({})
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)

	useEffect(() => {
		const fetchReports = async () => {
			try {
				setLoading(true)
				const data = await API.get('api/report/premade')
				setReports(data || {})
				setError(null)
			} catch (error) {
				console.error('Error fetching premade reports:', error)
				setError('Kunde inte ladda fördefinierade rapporter')
			} finally {
				setLoading(false)
			}
		}

		fetchReports()
	}, [])

	const loadReport = async (reportKey) => {
		try {
			const data = await API.post(`api/report/premade/${reportKey}/load`)
			if (onLoadReport) {
				onLoadReport(data)
			}
		} catch (error) {
			console.error('Error loading report:', error)
			setError(`Kunde inte ladda rapporten ${reportKey}`)
		}
	}

	if (loading) {
		return (
			<div className='text-center py-4'>
				<div className='spinner-border text-primary' role='status'>
					<span className='visually-hidden'>Laddar...</span>
				</div>
				<p className='mt-2 text-muted'>Laddar rapporter...</p>
			</div>
		)
	}

	if (error) {
		return (
			<div className='alert alert-danger'>
				<p className='mb-0'>{error}</p>
			</div>
		)
	}

	const getSwedishModelName = (modelName) => {
		const modelNames = {
			'Invoicebase': 'Hyresavi',
			'Company': 'Företag',
			'Entity': 'Objekt',
			'Lease': 'Uthyrning',
			'Tenant': 'Hyresgäst',
			'Maintenance': 'Förvaltning',
			'Ticket': 'Ärende',
			'Agreement': 'Avtal',
			'RentAdjustment': 'Hyresjustering'
		}
		return modelNames[modelName] || modelName
	}

	if (Object.keys(reports).length === 0) {
		return (
			<div className='text-center text-muted py-4'>
				<i className={`${icons.chart} fa-2x mb-3`}></i>
				<p>Inga fördefinierade rapporter tillgängliga.</p>
			</div>
		)
	}

	return (
		<div className='row'>
			{Object.entries(reports).map(([categoryName, categoryReports]) => (
				<div key={categoryName} className='col-12'>
					<Card title={categoryName} icon={icons.folder}>
						<table className='table table-hover mb-0'>
							<tbody>
								{categoryReports.map((report) => (
									<tr
										key={report.key}
										style={{ cursor: 'pointer' }}
										onClick={() => loadReport(report.key)}
									>
										<td style={{ width: '50px', verticalAlign: 'middle' }} className='text-center'>
											<i className={`${icons[report.icon] || icons.chart} text-muted fa-lg`}></i>
										</td>
										<td style={{ verticalAlign: 'middle' }}>
											<div className='fw-bold'>{report.name}</div>
											<small className='text-muted'>{report.description}</small>
										</td>
										<td style={{ width: '120px', verticalAlign: 'middle' }}>
											<span className='badge bg-dark'>
												{getSwedishModelName(report.model)}
											</span>
										</td>
										<td style={{ width: '40px', verticalAlign: 'middle' }} className='text-end'>
											<i className='fas fa-chevron-right text-muted'></i>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</Card>
				</div>
			))}
		</div>
	)
}
